import { onReady } from './util/onReady';
import { initSubNavbar, initDropdown } from '@bi-digital/react/vanilla';

onReady(() => {
    const subNavbar = document.querySelector<HTMLDivElement>(`.bi-sub-navbar`);
    initSubNavbar();

    const elements = [...document.querySelectorAll<HTMLDivElement>(`[data-section="true"][data-menu-label][id]`)];
    if (!subNavbar || !elements.length) return;

    const dropdownButton = subNavbar.querySelector<HTMLButtonElement>(`button[aria-controls]`);
    const dropdownId = dropdownButton?.getAttribute('aria-controls');
    const dropdownList = subNavbar.querySelector<HTMLDivElement>(`#${dropdownId} > ul`);

    if (!dropdownList || !dropdownButton || !dropdownId) return;

    const dropdownButtonTextNode = dropdownButton.querySelector('span[data-label]');
    const dropdownButtonText = dropdownButtonTextNode?.textContent; // Store the initial text of the dropdown button so it can be showed when no active link is found

    const toggleDropdown = initDropdown({ id: dropdownId, placement: 'bottom-start', padding: 0 });

    const dropdownLinks: {
        label: string;
        element: HTMLDivElement;
        link: HTMLAnchorElement;
    }[] = [];

    if (dropdownList) {
        elements.forEach((element) => {
            const label = element.getAttribute('data-menu-label');
            if (element.id && label) {
                const listItem = document.createElement('li');

                const link = document.createElement('a');
                link.className = 'bi-button';
                link.setAttribute('data-variant', 'text');
                link.href = `#${element.id}`;
                link.append(label);
                link.addEventListener('click', () => toggleDropdown?.(false));

                dropdownLinks.push({ link, label, element });
                listItem.appendChild(link);
                dropdownList.appendChild(listItem);
            }
        });
    }

    const updateActiveIndicator = () => {
        const activeDropdownLink =
            dropdownLinks.findLast(({ element }) => element.getBoundingClientRect().top < 84) || dropdownLinks[0];
        dropdownLinks.forEach(({ link }) => {
            link.setAttribute('aria-current', link === activeDropdownLink?.link ? 'true' : 'false');
        });

        if (dropdownButtonTextNode) {
            dropdownButtonTextNode.textContent = activeDropdownLink
                ? activeDropdownLink.label
                : dropdownButtonText || 'Go to ...';
        }
    };

    updateActiveIndicator();

    window.addEventListener('scroll', updateActiveIndicator);
});
